

 import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';

export const getboardofStudiesPriorityData = async () => {
    try {
        const response = await ApiClient.get(`homePage/aboutPage/getbosCount`);
       // console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}



export const updateboardofStudiesPriority = async ({ id, order }) => {
    try {
        const response = await ApiClient.put(`/homePage/aboutPage/updateBOSOrder/${id}`, 
            { order }, 
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        //console.log("Priority update response:", response);
        return response;
    } catch (error) {
        throw error;
    }
};
